<template>
    <div v-if="loaded">
        <rkm-row class="mt-1">
            <rkm-col>
                <div class="aviso-lei">
                    <p>
                        Este portal exibe informações de forma parcial e anonimizada, em estrita conformidade com a Lei Geral de Proteção de Dados Pessoais
                        <strong>(Lei nº 13.709/2018).</strong>
                    </p>
                    <p>
                        O tratamento dessas informações observa as bases legais previstas no art. 7º, incisos II e III, da LGPD, que autorizam o uso de dados pessoais para o cumprimento de obrigação legal e execução de políticas públicas, especialmente no contexto do Sistema Único de Saúde (SUS).
                    </p>
                    <p>
                        Os dados apresentados possuem finalidade exclusivamente informativa e administrativa, voltada à transparência no acesso e acompanhamento das filas de espera do SUS municipal, sem exposição de informações pessoais, sensíveis ou clínicas.
                    </p>
                </div>
            </rkm-col>
        </rkm-row>

        <rkm-tabs>
            <rkm-tab title="Solicitações em espera">
                <SolicitacaoEspera :customer="customer" />
            </rkm-tab>

            <rkm-tab title="Solicitações atendidas">
                <SolicitacaoAtendida :customer="customer" />
            </rkm-tab>
        </rkm-tabs>
    </div>
</template>

<script>
// Components.
import SolicitacaoEspera from './components/solicitacao-espera/Index'
import SolicitacaoAtendida from './components/solicitacao-atendida/Index'

// Mixins.
import { repository, error } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { SolicitacaoEspera, SolicitacaoAtendida },
    created() {
        this.repositories = {
            cliente: this.getConectaSusRepository('intranet.cliente'),
        }
    },
    data: () => ({
        customer: null,
        loaded: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading', 'clear', 'setCustomer',]),
        load(customer) {
            this.setLoading()

            this.repositories.cliente.index({ link: customer })
                .then(({ data }) => {
                    this.setCustomer(data)

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mounted() {
        const env = process.env.VUE_APP_ENV
        let customer = null

        if (env === 'production') {
            customer = window.location.hostname.split('.')[0]
        } else {
            customer = this.$route.params.customer
        }

        this.customer = customer

        if(customer) {
            this.clear().then(() => {
                this.load(customer)
            });
        }
    },
    mixins: [repository, error],
}
</script>

<style scoped>
.aviso-lei {
    background-color: #f8f9fa;
    border-left: 4px solid #0062cc;
    padding: 12px 16px;
    margin: 10px 0;
    border-radius: 6px;
    font-size: 0.95rem;
    line-height: 1.5;
    color: #333;
}

.aviso-lei p {
    margin: 4px 0;
}

.aviso-lei strong {
    color: #0062cc;
}
</style>